import { ReactElement } from 'react';
import Link from 'next/link';
import RealTimeText from 'components/Common/RealTimeText';
import Icon from 'components/Common/Icon';
import {
  GetTokenExpireTime,
  camelToSnake,
  getCookie,
  isValid,
  redirectToLoginPage,
  removeCookie,
  setCookie,
} from './common.util';
import request, { nodeEnv } from 'services/request';
import { LogoutUrl } from 'routes/account.routes';
import i18n from 'locales/fa.json';
import { PackagesRoute } from 'routes/wallet.routes';
import { StyledDiv } from 'theme/commonStyled';

// use in react toastify
export const CloseButton = ({ closeToast }): JSX.Element => (
  <Icon name="x-close" fontSize={10} onClick={closeToast} ml={3} />
);

export const paymentMessage = (): JSX.Element => {
  const { paymentMessage1, paymentMessage2, paymentMessage3 } =
    i18n.global.messages;
  return (
    <StyledDiv display="flex" gap={4}>
      {paymentMessage1}{' '}
      <StyledDiv color="berry40">
        <Link href={PackagesRoute()}>{paymentMessage2}</Link>
      </StyledDiv>{' '}
      {paymentMessage3}
    </StyledDiv>
  );
};

/**
 * The function that applies to a text and make it a
 * text component that gets bold upon changes, for 1 second
 * and then turns back to normal (see RealTimeText component).
 * @returns {Component} A function that applies to the text and outputs the
 * respective component.
 * @param renderer // send any formatter if you need
 * @param value
 */
export const realTimeText = (value): ReactElement | null =>
  isValid(value) && value !== '' ? <RealTimeText value={value} /> : null;

// we cant't test "request" file, so we move function here to use "common.utils" in tests
export const setUaaCookie = (access: string, refresh?: string): void => {
  const accessExpires = GetTokenExpireTime(access);
  const refreshExpires = GetTokenExpireTime(refresh);

  setCookie('pwa_access_token', access, {
    expires: accessExpires,
    path: '/',
    domain: process.env.NEXT_PUBLIC_FRONT_DOMAIN,
  });
  setCookie('pwa_refresh_token', refresh, {
    expires: refreshExpires,
    path: '/',
    domain: process.env.NEXT_PUBLIC_FRONT_DOMAIN,
  });
  request.setHeader('Authorization', `Bearer ${access}`);
};

// we can't test "request" file, so we move function here to use "common.utils" in tests
export const logoutAction = async (
  isManualLogout = false,
  isRefreshExpired = false,
): Promise<void> => {
  const refresh = getCookie('pwa_refresh_token');
  if (refresh && !isRefreshExpired)
    await request.post(LogoutUrl(), { refresh });
  request.setHeader('Authorization', '');
  removeCookie('pwa_access_token');
  removeCookie('pwa_refresh_token');
  redirectToLoginPage(isManualLogout);
};

export const putMenuDataLayer = (menu: string, subMenu = ''): void => {
  if (typeof window !== undefined && nodeEnv === 'production') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'menu_click',
      menu_title: menu,
      submenu_title: camelToSnake(subMenu),
    });
  }
};

export const signedIcon = (value: number): JSX.Element =>
  value !== 0 && (
    <Icon
      name={value >= 0 ? 'caret-up' : 'caret-down'}
      color={value >= 0 ? 'grass80' : 'rose80'}
      mr={2}
      fontSize={2}
    />
  );
